import get from 'lodash/get';
import { Data } from 'prismic/types';
import { PRISMIC_API_IDS } from 'prismic/config';
import Meta from './partials/Meta';
import Opengraph from './partials/Opengraph';
import Favicons from './partials/Favicons';

interface HeadProps {
  data: Data;
  children?: React.ReactNode;
}

const HeadWrapper: React.FC<HeadProps> = ({ data, children }) => {
  const title = get(data?.data, PRISMIC_API_IDS.metaTitle, null);
  const description = get(data?.data, PRISMIC_API_IDS.metaDescription, null);
  const siteName = get(data?.data, PRISMIC_API_IDS.ogSitename, null);
  const ogImage = get(data?.data, PRISMIC_API_IDS.ogImage, null);
  const ogTitle = get(data?.data, PRISMIC_API_IDS.ogTitle, null);
  const ogDescription = get(data?.data, PRISMIC_API_IDS.ogDescription, null);
  const canonical = get(data?.data, PRISMIC_API_IDS.metaCanonical, null);
  const shouldIndex = get(data?.data, PRISMIC_API_IDS.metaIndex, true);

  return (
    <>
      <Meta
        title={title}
        description={description}
        canonical={canonical}
        shouldIndex={shouldIndex}
      />
      <Opengraph
        title={ogTitle || title}
        description={ogDescription || description}
        image={ogImage}
        url={canonical}
        siteName={siteName}
      />
      <Favicons />

      {children}
    </>
  );
};

export default HeadWrapper;
